<div (click)="onClickInput()" [class.error]="isNotValid">
  <ng-content />
</div>
